import React from "react";
import iconPhao from "../../../../../assets/images/Event-2025/Asset 4@4x (1).png";
import "./PackSuccess.scss";
import { useQuery } from "react-query";
import { getCheckStatusEvent } from "dataLayer/product";

export default function PackSuccess({
  isSuccessSubPack,
  selectedPack,
  icon,
  isShow = true,
}) {
  const { data: statusEvent } = useQuery(getCheckStatusEvent());
  const handleGetTotalFly = () => {
    switch (selectedPack) {
      case "SUBASTA_DAILY":
        return "+5";
      case "SUBASTA_WEEKLY":
        return "+10";
      case "SUBASTA_MONTHLY":
        return "+50";
      case "CHANCE":
        return "+2";
      case "CHANCE2":
        return "+5";
      case "CHANCE5":
        return "+15";
      case "CHANCE10":
        return "+25";
      default:
        return "+5";
    }
  };

  if (!statusEvent?.is_show || statusEvent?.is_finished || !isSuccessSubPack) {
    return null;
  }

  return (
    <div id="imgFlyContainer" style={{ opacity: isShow ? "1" : 0 }}>
      {isSuccessSubPack ? (
        <div
          style={{
            opacity: `${isSuccessSubPack ? "1" : "0"}`,
          }}
        >
          <div
            className="image-fly"
            style={{
              transform: "translate(-50%, -50%)",
              zIndex: "9999",
            }}
          >
            <img src={icon || iconPhao} alt="" className="icon-animation" />
            <div className="total-flys">
              {icon ? "+3" : handleGetTotalFly()}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
